// Galaxy League — zentrale Inhalte (DE). An einem Ort fuer einfache Pflege.

export const BRAND = {
  name: "GALAXY LEAGUE",
  tagline: "1 Day. 1 Champion.",
  premiere: "2026 \u00B7 WIEN",
};

// Navigation: nur real existierende Ziele. Weitere Seiten (Spielplan,
// Tabelle, Regeln, News) werden ergaenzt, sobald sie erstellt sind.
export const TICKETS = {
  url: "https://www.eventim-light.com/at/a/6ac56a79029cee9fb46506e5/e/6ac7cd3b32733c9d9cec73f5/?campaign=Website",
  cta: "TICKETS SICHERN",
  bannerBadge: "EARLY BIRD",
  bannerText: "Early-Bird-Tickets sind da \u2013 nur f\u00FCr kurze Zeit zum Vorteilspreis.",
  bannerShort: "Tickets da \u2013 nur kurze Zeit!",
  bannerCta: "Jetzt sichern",
};

export const NAV_LINKS = [{ label: "Kontakt", href: "/kontakt" }];

export const HERO = {
  badge: BRAND.premiere,
  headlineLine1: "1 DAY.",
  headlineLine2: "1 CHAMPION.",
  description:
    "Das spektakul\u00E4rste Hallenfu\u00DFball-Event des Jahres: Bande, prominente Captains und ein eigenes Regelwerk \u2013 Football beyond limits. Acht Teams, zwei Gruppen, ein Tag, ein Champion. Sei dabei, wenn Wien Geschichte schreibt.",
  primaryCta: "TICKETS SICHERN",
  secondaryCta: "REGELWERK ENTDECKEN",
  announcement: "Das Datum, die Teams und die Star-Captains werden bald enth\u00FCllt \u2013 verpass den Moment nicht. Bleib dran.",
};

export const STATS = [
  { value: "4 + 1", label: "KLEINFELD" },
  { value: "2 \u00D7 12\u2032", label: "HALBZEITEN" },
  { value: "Kein", label: "ABSEITS" },
  { value: "5", label: "GALAXY MOMENTS" },
];

export const FOOTER = {
  copyright: "\u00A9 2026 Galaxy League",
  socials: [
    {
      label: "Instagram",
      icon: "instagram",
      href: "https://www.instagram.com/thegalaxyleague/",
    },
  ],
  legal: [
    { label: "Impressum", href: "/impressum" },
    { label: "Datenschutz", href: "/datenschutz" },
    { label: "Kontakt", href: "/kontakt" },
  ],
};

export const CAPTAINS = {
  badge: "DIE CAPTAINS",
  headline: "ACHT CAPTAINS. NACH UND NACH ENTH\u00DCLLT.",
  intro:
    "Jedes Team wird von einer prominenten Pers\u00F6nlichkeit aufs Feld gef\u00FChrt. Wer die acht Teams der Galaxy League anf\u00FChrt, wird Schritt f\u00FCr Schritt enth\u00FCllt \u2013 sei dabei, wenn die Namen fallen.",
  count: 8,
  // Bereits enth\u00FCllte Captains (in Reihenfolge der Bekanntgabe).
  list: [
    {
      name: "Jakob Jantscher",
      tags: ["Ex-Profi", "Sturm Graz", "\u00D6FB Nationalteam"],
      image: "jantscher",
    },
    {
      name: "Manprit Sarkaria",
      tags: ["Profi", "FK Austria Wien"],
      image: "sarkaria",
    },
    {
      name: "\u00DCmit Korkmaz",
      tags: ["Ex-Profi", "Rapid Wien Legende", "\u00D6FB Nationalteam"],
      image: "korkmaz",
    },
  ],
};

export const ARENA = {
  badge: "DER SCHAUPLATZ",
  headline: "NEURO.IO ARENA",
  city: "WIEN",
  intro:
    "Hier wird Geschichte geschrieben. F\u00FCr einen Tag verwandelt sich die neuro.io Arena mitten in Wien in das Zuhause der Galaxy League \u2013 6.000 Fans auf den R\u00E4ngen, LED-Banden und Flutlicht. Eine B\u00FChne, die jeder Begegnung das Gewicht eines Finales verleiht.",
  caption: "NEURO.IO ARENA \u00B7 WIEN",
  facts: [
    { value: "6.000", label: "ERWARTETE FANS" },
  ],
  exteriorLabel: "3D \u00B7 ANSICHT",
};

export const CTA = {
  badge: "TICKETS JETZT ERH\u00C4LTLICH",
  headline: "SICHER DIR DEINEN PLATZ.",
  text: "Acht Teams, zwei Gruppen, ein Tag \u2013 mitten in der neuro.io Arena Wien. Sichere dir jetzt dein Early-Bird-Ticket, solange das Kontingent reicht, und sei live dabei, wenn Wien Geschichte schreibt.",
  button: "TICKETS SICHERN",
};

export const CONTACT = {
  badge: "SAG HALLO",
  headline: "KONTAKT",
  intro:
    "Die Galaxy League wird das spektakul\u00E4rste Hallenfu\u00DFball-Event des Jahres \u2013 und du kannst Teil davon werden. Ob Teams, Captains, Partner oder Presse: Schreib uns und sei dabei, wenn Wien Geschichte schreibt.",
  submitLabel: "Nachricht senden",
  successTitle: "Nachricht gesendet!",
  successMessage:
    "Danke f\u00FCr deine Nachricht. Wir melden uns so bald wie m\u00F6glich bei dir.",
  errorMessage:
    "Etwas ist schiefgelaufen. Bitte versuche es erneut oder schreib uns direkt per E-Mail.",
};

// Unternehmensdaten fuer Impressum & Datenschutz (Stand 2026, Oesterreich).
// Hinweis: Firmenbuchnummer (FN), Firmenbuchgericht und UID sind fuer eine GmbH
// gesetzlich verpflichtend (§ 5 ECG, § 14 UGB) und vom Betreiber nachzutragen.
export const COMPANY = {
  legalName: "RS Sports & Entertainment GmbH",
  street: "Fl\u00F6tzersteig 1",
  zip: "1160",
  city: "Wien",
  country: "\u00D6sterreich",
  email: "office@galaxyleague.at",
  phone: "+43 676 7222182",
  managingDirector: "Ramin Shehad",
  registerNumber: "FN 645426 g",
  registerCourt: "Handelsgericht Wien",
  foundedDate: "27.01.2025",
  businessPurpose:
    "Eventmanagement, Sportveranstaltungen, Sportmanagement, Sportlermanagement",
  // Bitte noch nachtragen:
  vatId: "[UID-Nummer einf\u00FCgen, z. B. ATU########]",
  lastUpdated: "Juni 2026",
};

export const REGISTRATION = {
  badge: "BEWERBUNG",
  headline: "MELDE DEIN TEAM AN.",
  headlineEmphasis: "AN.",
  intro:
    "Jedes Team tritt mit einem Influencer an \u2014 ohne Influencer-Handle keine Bewerbung. Jeder kann sich bewerben: vom Hobbyteam bis zur eingespielten Truppe.",
  platformOptions: [
    { value: "instagram", label: "Instagram" },
    { value: "tiktok", label: "TikTok" },
  ],
  teamTypeOptions: [
    { value: "new", label: "Neu gegr\u00FCndet" },
    { value: "extra", label: "Extra f\u00FCr die Galaxy League" },
    { value: "established", label: "Etabliert" },
    { value: "longer", label: "Wir spielen schon l\u00E4nger zusammen" },
  ],
  selfAssessmentOptions: [
    { value: "liga1", label: "Liga 1", prize: "20.000 \u20AC" },
    { value: "liga2", label: "Liga 2", prize: "5.000 \u20AC" },
    { value: "hobby", label: "Hobbyliga", prize: "\u00DCberraschungspreis" },
  ],
  submitLabel: "Bewerbung absenden",
  confirmationNote:
    "Mit dem Absenden best\u00E4tigst du, dass der angegebene Influencer Teil eures Teams ist.",
  successTitle: "Bewerbung gesendet!",
  successMessage:
    "Danke f\u00FCr eure Bewerbung. Wir melden uns bei euch \u2014 bleibt dran!",
  errorMessage:
    "Etwas ist schiefgelaufen. Bitte versuche es erneut oder kontaktiere uns.",
};
